export const BASE_URL = process.env.REACT_APP_BASE_URL
export const MOCK_BASE_URL = "http://192.168.1.3:5000"